import { useAuth } from "@/provider/auth.provider";
import { UserRole } from "@/utils/enum/user-role.enum";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { PageLoader } from "./page-loader";

interface ProtectedRouteProps {
  role?: UserRole[]; // Added role prop to specify required role
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ role }) => {
  const { isAuthenticated, loading, user } = useAuth(); // Added user to check role
  const location = useLocation();

  if (loading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Additional check for SUPER_ADMIN role, if strict client-side check is desired
  // The backend already enforces this, but this can provide quicker feedback or UI changes.
  if (role && !role.includes(user?.role!)) {
    console.warn("Access denied: User is authenticated but not SUPER_ADMIN.");
    console.log(
      "user, isAuthenticated, loading: role.includes(user?.role!)",
      user,
      isAuthenticated,
      loading,
      role?.includes(user?.role!)
    );
    // Optionally, show a specific "Access Denied" page or redirect to home.
    // For now, redirecting to home if not SUPER_ADMIN, even if authenticated.
    return (
      <Navigate
        to="/"
        state={{ message: "Access Denied: SUPER_ADMIN role required." }}
        replace
      />
    );
  }

  return <Outlet />;
};
